<template>
<div :class="{'pp-tracklist':1, 'pp-tracklist--mini':1, 'pp-tracklist--reverse': reversed }">
    <div v-for="item, index in items" v-if="!maxRows || index < maxRows"
         :class="{'pp-tracklist__item':1, 'pp-tracklist__item--playing': currentTrack && item.id == currentTrack.id }"
         @dblclick="playTrack(item)">
        <div  class="pp-tracklist__item__container">
            <div class="pp-tracklist__item__number">
                {{ item.position }}.
            </div>
            <div class="pp-tracklist__item__title">
                {{ item.title }}
            </div>
            <div class="pp-tracklist__item__playnow" @click="playTrack(item)">
                <i class="fa fa-fw fa-play"></i>
            </div>
            <div class="pp-tracklist__item__playing">
                <i class="fa fa-fw fa-volume-up"></i>
            </div>
            <div @click="removeTrack(index)" class="pp-tracklist__item__remove">
                <i class="fa fa-fw fa-close"></i>
            </div>
        </div>
    </div>
    <div v-if="items.length == 0" class="pp-tracklist__zerostate">
        {{ this.zerostate }}
    </div>
</div>
</template>


<script>
import EventBus from '../EventBus.js';
import TrackQueue from '../TrackQueue';

export default {
    name: 'track-list',
    data() {
        return {
            currentTrack: null,
        };
    },
    mounted() {
        TrackQueue.on('changed', (e) => {
            this.reloadPlaying();
        });

        this.reloadPlaying();
    },
    methods: {
        reloadPlaying() {
            this.currentTrack = TrackQueue.current;
        },
        playTrack(track) {
            if (this.currentTrack && item.id == currentTrack.id) { return; }
            EventBus.emit('core.track.play', {
                track: track,
                context: this.items,
                mode: this.contextMode
            });
        },
        removeTrack(index) {
            EventBus.emit('core.queue.removeTrack', {
                index: index,
                mode: this.contextMode
            });
        }
    },
    props: {
        items: Array,
        maxRows: Number,
        contextMode: String,
        zerostate: String,
        reversed: Boolean
    },

}
</script>



// WEBPACK FOOTER //
// MiniTrackList.vue?63b7bf70